define( [ "./selector-sizzle" ], function() {} );



//////////////////
// WEBPACK FOOTER
// /var/www/html/themes/base/node_modules/jquery/src/selector.js
// module id = 6
// module chunks = 8